import React from 'react';
import event, { EVENTS } from '../../lib/event.js';
import { render } from 'react-dom';
import XiaoaoEdit from './xiaoao-edit';

/*
  参考ModalManager封装的CartoonEditor类
  调用CartoonEditor.cartoon可打开步骤录制弹窗（弹窗唯一不可重复打开）
  挂载到window对象,可直接通过window.cartoon调用
*/

class XiaoAoBox {

    static cartoonHide() {
        const xiaoao = document.getElementById('xiaoao')
        if(xiaoao){
            document.getElementById('xiaoao').remove();
        }
    }

    static cartoon(btnText, position = 'right',type = 'default') {
        const doc = window.document
        const node = doc.createElement('div')
        node.id = 'xiaoao' // 保证打开唯一的窗口
        if (doc.getElementById('xiaoao')) {
            return
        }
        doc.body.appendChild(node)
        render((
            <XiaoaoEdit type={type} btnText={btnText} position={position} />
        ), node)
    }
}

// 挂载到window对象
window.xiaoao = XiaoAoBox.cartoon
window.xiaoaoHide = XiaoAoBox.cartoonHide

export default XiaoAoBox
